import "./../../bindings/bao-toolbar2";
import "./../../bindings/foreach-selection";
import "./../../bindings/bao-pager";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function Device3Device4AssignmentTab(tabPage, device3ViewModel) {
    var self = this;
    self.TabPage = tabPage;
    self.Device3ViewModel = device3ViewModel;
    self.Selection = ko.observableArray();
    self.SelectedDevice4Ids = ko.observableArray();
    self.Sorting = ko.observableArray();
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.TotalRows = ko.observable();
    self.Models = ko.observableArray();
    self.NewArray = ko.observableArray([]);
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.PageSize.subscribe(function () {
        if (self.PageIndex() != 0) {
            self.PageIndex(0);
        }
        else {
            self.Refresh();
        }
    });
    self.Sorting.subscribe(function () {
        self.Refresh();
    });
    self.Selection.subscribe(function () {
        self.toggleButtons();
    });
    self.SelectedDevice4Ids.subscribe(function (SelectedDevice4Ids) {
        if (SelectedDevice4Ids != null && SelectedDevice4Ids.length > 0) {
            var device4Ids = [];
            ko.utils.arrayForEach(SelectedDevice4Ids, function (item: any) {
                device4Ids.push(ko.unwrap(item.Device4Id));
            });
            self.addDevice4ToSession(device4Ids);
        }
    });
    self.toolbarButtonClicked = function (btn) {
        if (self.TabPage != null && self.TabPage.IsActiveTab != null && self.TabPage.IsActiveTab() === true) {
            var functionString = btn.ActionKey().substr(('Device3Device4Assignment').length);
            switch (functionString) {
                case 'Add':
                    self.addDevice4();
                    break;
                case 'Remove':
                    self.removeDevice4();
                    break;
                default:
                    break;
            }
        }
    };
    self.toolbarLoaded = function () {
        self.toggleButtons();
    };
    self.addDevice4 = function (device4) {
        this.openDevice4Searcher();
    };
    self.openDevice4Searcher = function () {
        self.SelectedDevice4Ids([]);
    };
}
;
Device3Device4AssignmentTab.prototype.Refresh = function () {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("MasterData/Device3/GetAssignedDevice4", JSON.stringify({
        sessionTabId: self.Device3ViewModel.SessionTabId(),
        device3Id: self.Device3ViewModel.Device3Id(),
        pageIndex: self.PageIndex(),
        pageSize: self.PageSize(),
        sorting: self.Sorting()
    }), function (searchResult) {
        self.SelectedDevice4Ids([]);
        self.NewArray([]);
        self.TotalRows(0);
        self.Models([]);
        if (searchResult != null && searchResult.Models != null) {
            self.Models(searchResult.Models);
            self.TotalRows(searchResult.TotalRows);
            self.toggleButtons();
        }
    }).always(function () {
        self.TabPage.IsLoading(false);
    });
};
Device3Device4AssignmentTab.prototype.toggleButtons = function () {
    if (this.enableButton != undefined) {
        var selection = this.Selection.peek();
        this.enableButton('Device3Device4AssignmentRemove', selection && (selection.length > 0));
    }
};
Device3Device4AssignmentTab.prototype.removeDevice4 = function (a, b, c) {
    var self = this;
    self.TabPage.IsLoading(true);
    var device4Ids = [];
    ko.utils.arrayForEach(self.Selection(), function (item: any) {
        device4Ids.push(ko.unwrap(item.Device4Id));
    });
    return Bao.post("MasterData/Device3/DeleteDevice4", JSON.stringify({
        sessionTabId: self.Device3ViewModel.SessionTabId(),
        device3Id: self.Device3ViewModel.Device3Id(),
        device4Ids: device4Ids
    }), function () {
        self.Device3ViewModel.TabPage.DirtyFlag(true);
        self.Refresh();
    });
};
Device3Device4AssignmentTab.prototype.addDevice4ToSession = function (device4Ids) {
    var self = this;
    self.TabPage.IsLoading(true);
    return Bao.post("MasterData/Device3/AddDevice4", JSON.stringify({
        sessionTabId: self.Device3ViewModel.SessionTabId(),
        device3Id: self.Device3ViewModel.Device3Id(),
        device4Ids: device4Ids
    }), function () {
        self.Device3ViewModel.TabPage.DirtyFlag(true);
        self.Refresh();
    });
};
export default Device3Device4AssignmentTab;